import * as types from './location_types';

const initialState = {
  // Delivery location
  deliveryLocation: '',
  selectedDeliveryCoords: null,
  deliveryDistance: null,
  locationSuggestions: [],
  isSearchingLocation: false,
  
  // UI state
  showLocationModal: false,
  currentLocationLoading: false,
  
  // Errors
  errors: {
    deliveryLocation: '',
    currentLocation: ''
  },
};

const locationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ADDRESS_FROM_LOC: {
      const addr = action.payload.address || '';
      const isLatLngFallback = addr.startsWith('Lat:') && addr.includes('Lng:');
      return {
        ...state,
        deliveryLocation: isLatLngFallback ? state.deliveryLocation : addr,
        currentLocationLoading: false,
        errors: {
          ...state.errors,
          currentLocation: action.payload.success ? '' : action.payload.error,
          ...(action.payload.success ? { deliveryLocation: '' } : {})
        }
      };
    }
    
    case types.GET_ADDRESS_FROM_LOC_RESPONSE:
      return {
        ...state,
        locationSuggestions: action.payload.success ? action.payload.suggestions || [] : [],
        isSearchingLocation: false,
        errors: {
          ...state.errors,
          locationSearch: action.payload.success ? '' : action.payload.error
        }
      };
    
    case types.LOCATION_ERROR: {
      const { field, error } = action.payload;
      return {
        ...state,
        errors: {
          ...state.errors,
          [field]: error
        }
      };
    }
    default:
      return state;
  }
};

export default locationReducer;
